import apiClient from 'services/axios'
/* eslint-disable */
export const fetchAgentPayments = async ({ agentId, queryParams }) => {
  const queryString = new URLSearchParams(queryParams).toString()
  return apiClient
    .get(`agent/sales-agent/${agentId}/payments?${queryString}`)
    .then(response => response.data)
    .catch(err => {
      console.error('Fetch agent payments failed:', err)
      return { error: true, message: err.message }
    })
}

export const fetchAgentPaymentDetails = async ({ agentId, paymentId }) => {
  return apiClient
    .get(`agent/sales-agent/${agentId}/payment/${paymentId}`)
    .then(response => response.data)
    .catch(err => {
      console.error('Fetch agent payment details failed:', err)
      return {
        error: true,
        message: err?.response?.data?.message || err.message,
      }
    })
}
